import React, { Component } from 'react'
import gps from "../../assets/images/gps.svg"
import ripple from "../../assets/images/ripple.svg";
import {connect} from "react-redux";
import {pickPos, dropPos} from "../../actions";
import { location } from '../../actions/geolocation';

class Placemarker extends Component {

    state = {
        fetching: false
    }

    pickLoc(){
        this.setState({fetching: true});
        location().then(res => {
            this.setState({fetching: false});
            let {latitude , longitude} = res.coords;
            this.props.pickPos({lat: latitude, lng: longitude}, "P");
        }).catch(err => {
            this.setState({fetching: false});
            console.log(err);
        })
    }

    render() {
        return (
            <div className="gps" onClick={() => this.pickLoc()}>
                <img src={this.state.fetching ? ripple : gps} height="20" alt="" />
            </div>
        )
    }
}

const mapStateToProps = ({bookingLoc}) => ({
    P: bookingLoc.pickup,
    D: bookingLoc.drop,
})

const mapDispatchToProps = {pickPos, dropPos};

export default connect(mapStateToProps, mapDispatchToProps)(Placemarker)